import { createRouter, createWebHashHistory, type RouteRecordRaw } from 'vue-router';
import { openJobFormEdit, openJobFormNew } from './job-form-modal';

const routes: RouteRecordRaw[] = [
  { path: '/', redirect: '/dashboard' },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('./pages/DashboardPage.vue'),
  },
  {
    path: '/jobs',
    name: 'jobs',
    component: () => import('./pages/JobsPage.vue'),
  },
  {
    path: '/jobs/new',
    name: 'job-new',
    redirect: '/dashboard',
    beforeEnter: (to, _from, next) => {
      openJobFormNew(to.query.draft as string | undefined);
      next();
    },
  },
  {
    path: '/jobs/:rowIndex',
    name: 'job-edit',
    redirect: '/jobs',
    beforeEnter: (to, _from, next) => {
      openJobFormEdit({
        _rowIndex: Number(to.params.rowIndex),
        _sheetName: to.query.sheet as string | undefined,
      });
      next();
    },
  },
  {
    path: '/calendar',
    name: 'calendar',
    component: () => import('./pages/CalendarPage.vue'),
  },
  {
    path: '/schedule',
    name: 'schedule',
    component: () => import('./pages/ScheduleConflictsPage.vue'),
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import('./pages/SettingsPage.vue'),
  },
  {
    path: '/logs',
    name: 'logs',
    component: () => import('./pages/LogsPage.vue'),
  },
];

export const router = createRouter({
  history: createWebHashHistory(),
  routes,
});
